import '@babel/polyfill'
import 'nodelist-foreach-polyfill'

const selectors = {
  option: '[data-landing-option]',
  thumb: '[data-landing-thumb]',
  header: '[data-landing-header]'
}

export default () => {
  const header = document.querySelector(selectors.header)
  const options = document.querySelectorAll(selectors.option)
  const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

  if (!header) {
    return
  }

  setTimeout(() => {
    header.classList.add('-active')
  }, 500)

  options.forEach((option, index) => {
    const type = option.dataset.landingOption

    setTimeout(() => {
      option.classList.add('-active')
    }, 1000)

    if (width > 768) {
      option.addEventListener('mouseover', () => {
        document.querySelector('[data-landing-thumb="' + type + '"]').classList.add('-active')
      })

      option.addEventListener('mouseleave', () => {
        document.querySelector('[data-landing-thumb="' + type + '"]').classList.remove('-active')
      })
    }
  })
}
